import { IUpdateRawQueryListApiModel, UpdateType } from '@models/Update.model';
import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';
import { api } from '@services';

interface IPatchUpdate {
  id: string;
  subject: string;
  description: string;
  originalMessage: string;
  productsIds: string[];
  tagsIds: string[];
  manufacturersIds: string[];
  dataDate: Date;
  dueDate: Date;
  type: UpdateType;
  usType: UpdateStatusType;
  priority?: UpdateStatusPriority;
}

const patchUpdate = async ({
  id,
  ...data
}: IPatchUpdate): Promise<IUpdateRawQueryListApiModel> => {
  const { data: update } = await api.patch<IUpdateRawQueryListApiModel>(
    `/updates/${id}`,
    data,
  );

  return update;
};

export { patchUpdate };
